import { API } from "../../config";
import axios from 'axios';
import { normalizeCourierServices } from "../../services/helpers/courier";

export const getLogisticPricing = async (token, origin, destination, items,couriers,type) => {
    let sentItems;
    if (items[0].quantity === 0) {
        sentItems = []
    } else {
        sentItems = items;
    }
    try {
        let data;
        if (type === 'postalCode') {
            data = {
                origin_postal_code:origin,
                destination_postal_code:destination,
                couriers:couriers.toString(),
                items:sentItems
            }
        } else {
            data = {
                origin_latitude:origin.latitude,
                origin_longitude:origin.longitude,
                destination_latitude:destination.latitude,
                destination_longitude:destination.longitude,
                couriers:couriers.toString(),
                items:sentItems
            }
        }

        const res = await axios.post(`${API}/v1/pricing/couriers?channel=web_dashboard`, data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                },
            });

        if (res.data.success){
            let pricing = res.data.pricing.reduce((res,i) => {
                let serviceType;
                if (i.service_type === 'same_day') {
                    serviceType = 'sameDay';
                } else {
                    serviceType = i.service_type
                }

                if (
                    (
                        i.company === 'gojek' ||
                        i.company === 'grab'||
                        i.company === 'deliveree' || 
                        i.company === 'lalamove' || 
                        i.company === 'rara'
                    ) && (
                        i.courier_service_code == 'instant' ||
                        i.courier_service_code == 'motorcycle' ||
                        i.courier_service_code == 'mpv' ||
                        i.courier_service_code == 'van' ||
                        i.courier_service_code === 'economy' ||
                        i.courier_service_code === 'small_pickup' ||
                        i.courier_service_code === 'car_express'
                    )
                ) {
                    serviceType = 'instant'
                }

                res.push({
                    company:i.company,
                    courierName: i.courier_name,
                    courierCode: i.courier_code,
                    courierServiceName: i.courier_service_name,
                    courierServiceCode: i.courier_service_code,
                    description:i.description,
                    duration: `${i.shipment_duration_range} ${i.shipment_duration_unit}`,
                    price:i.price,
                    serviceType,
                    shippingType: i.shipping_type,
                    type: normalizeCourierServices(i.company, i.type).typeCamelCaseFormat
                });
                return res
            }, []);
            let response = {
                success:res.data.success,
                message:res.data.message,
                origin: {
                    address:res.data.origin.address,
                    subdistrictName:res.data.origin.subdistrict_name,
                    districtName:res.data.origin.district_name,
                    cityName:res.data.origin.city_name,
                    provinceName:res.data.origin.province_name,
                    postalCode:res.data.origin.postal_code
                },
                destination: {
                    address:res.data.destination.address,
                    subdistrictName:res.data.destination.subdistrict_name,
                    districtName:res.data.destination.district_name,
                    cityName:res.data.destination.city_name,
                    provinceName:res.data.destination.province_name,
                    postalCode:res.data.destination.postal_code
                },
                pricing
            };
            return response
        } else {
            return {
                success:false,
                error:res.data.error
            }
        }
    } catch (e) {
        return {
            success:false,
            error: e.response.data.error
        }
    }

};

export const getPublicLogisticPricing = async (userId, catalogId, origin, destination, items, couriers, type, postalCode) => {
    let sentItems,data;
    if (items[0].quantity === 0) {
        sentItems = []
    } else {
        sentItems = items;
    }

    if (type === 'postalCode') {
        data = {
            origin_latitude:origin.latitude,
            origin_longitude:origin.longitude,
            destination_postal_code:postalCode,
            couriers:couriers.toString(),
            items:sentItems
        }
    } else {
        data = {
            origin_latitude:origin.latitude,
            origin_longitude:origin.longitude,
            destination_latitude:destination.latitude,
            destination_longitude:destination.longitude,
            couriers:couriers.toString(),
            items:sentItems
        }
    }

    try {
        const res = await axios.post(`${API}/v1/pricing/couriers/${catalogId}/public/${userId}`,data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
            });
        if (res.data.success){
            let pricing = res.data.pricing.reduce((res,i) => {
                res.push({
                    company:i.company,
                    type: normalizeCourierServices(i.company, i.type).typeCamelCaseFormat,
                    description:i.description,
                    price:i.price,
                    duration:i.duration,
                });
                return res
            }, []);
            pricing = pricing.filter(i => i.type !== 'oke' && i.type !== 'crg');

            let response = {
                success:res.data.success,
                message:res.data.message,
                origin: {
                    address:res.data.origin.address,
                    subdistrictName:res.data.origin.subdistrict_name,
                    districtName:res.data.origin.district_name,
                    cityName:res.data.origin.city_name,
                    provinceName:res.data.origin.province_name,
                    postalCode:res.data.origin.postal_code,
                },
                destination: {
                    address:res.data.destination.address,
                    subdistrictName:res.data.destination.subdistrict_name,
                    districtName:res.data.destination.district_name,
                    cityName:res.data.destination.city_name,
                    provinceName:res.data.destination.province_name,
                    postalCode:res.data.destination.postal_code,
                },
                pricing
            };
            return response
        } else {
            alert("Alamat yang Anda pilih kurang spesifik. Usahakan masukan alamat seperti nama toko, nama komplek perumahan atau nama jalan. Terima kasih.");
            return res.data
        }
    } catch (e) {
        return {
            success:false,
            error: e.response.data.error
        }
    }
};
